import { StarIcon } from '@heroicons/react/24/solid'

import { RequestRating } from '@/api/models/requests/lib/requests.types'
import { cn } from '@/app/utils'
import { ExpandableText } from '@/components/shared/expandable-text'

const ContentRequestRaitingResult = ({ rating }: { rating: RequestRating }) => (
  <div data-testid="request-rating-result-id">
    <p className="mb-8 font-bold text-grey-90 text-16">Ваша оценка</p>
    <div className="flex justify-start">
      {Array.from({ length: rating.rating ?? 0 }).map((_, index) => (
        <StarIcon
          key={index}
          data-testid="request-rating-star-id"
          className={cn(
            'bronze-40',
            'h-30',
            'w-30',
            'text-bronze-40',
            index > 0 ? 'ml-4' : ''
          )}
        />
      ))}
    </div>
    {rating.comment && <ExpandableText text={rating.comment} />}
  </div>
)

export { ContentRequestRaitingResult }
